import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "./Index"

export default function NotFound() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>404 Page not found</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="The page you are looking for does not exist." />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="main-body-content main-container-global-adjusted-padding">
        <div className="page-not-found">
          <div>
            <h3>404</h3>
            <p className="page-not-found--title">Hi Ka-FGH!</p>
            <p className="page-not-found--content">
              "Looks like you’ve hit a dead end. The page you’re looking for
              either doesn’t exist, has been moved, or was never here in the
              first place."
            </p>
            <div>
              <img
                src="/images/character/FGH_CHARACTER-DISAPPOINTED.webp"
                alt="FGH-SAD"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
